module.exports = __webpack_public_path__ + "static/media/cm.06ca137e.png";